import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TCMEmailRequest } from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor(private http: HttpClient) {}

  sendEmail(emailRequest: TCMEmailRequest): Observable<any> {
    return this.http.post('secure/email', emailRequest);
  }
}
